import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth-slice";
import userReducer from "./features/user-slice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    auth: authReducer,
  },
});
